module.exports = __webpack_public_path__ + "static/media/Loading.1133ffb2.svg";